export const RISK_ROLE_DEFAULT = 'DEFAULT_PLAYER'
export const RISK_ROLE_BLACKLIST = 'BLACKLIST_PLAYER'
export const RISK_ROLE_BIG_RICH = 'BIG_RICH_PLAYER'

export const RISK_LABEL_DEFAULT = 'DEFAULT'
export const RISK_LABEL_HONEYMOON_1 = 'HONEYMOON_1'
export const RISK_LABEL_HONEYMOON_2 = 'HONEYMOON_2'
export const RISK_LABEL_BLACKLIST = 'BLACKLIST'
export const RISK_LABEL_BIG_RICH_COMPENSATION = 'BIG_RICH_COMPENSATION'
export const RISK_LABEL_BIG_RICH_COMPENSATION_CANCEL = 'BIG_RICH_COMPENSATION_CANCEL'
export const RISK_LABEL_CONTINUOUS_LOSING = 'CONTINUOUS_LOSING'
export const RISK_LABEL_WATERPOOL_PREVENTION_MANUAL = 'WATERPOOL_PREVENTION_MAMUAL'
export const RISK_LABEL_WATERPOOL_PREVENTION_YELLOW = 'WATERPOOL_PREVENTION_YELLOW'
export const RISK_LABEL_WATERPOOL_PREVENTION_RED = 'WATERPOOL_PREVENTION_RED'

export const COMPENSATION_STATE_PRIZED = 'prized'
export const COMPENSATION_STATE_CANCEL = 'cancel'
export const COMPENSATION_STATE_PENDING = 'pending'

export const RISK_LEVEL_STANDARD = 'STANDARD'
export const RISK_LEVEL_HONEYMOON = 'HONEYMOON'
export const RISK_LEVEL_BLACKLIST = 'BLACKLIST'
export const RISK_LEVEL_BIGRICH = 'BIG_RICH_COMPENSATION'

export const MAX_FLOAT = 99999999.0

export const BAN_SCORE_NOT_SUPPORT = [126]

export const RISK_FEATURE_BUY = 'BUYSLOTGAME'
